import { render, staticRenderFns } from "./CustomUIProject.vue?vue&type=template&id=909a1542&scoped=true&"
import script from "./CustomUIProject.vue?vue&type=script&lang=js&"
export * from "./CustomUIProject.vue?vue&type=script&lang=js&"
import style0 from "./CustomUIProject.vue?vue&type=style&index=0&id=909a1542&scoped=true&lang=css&"
import style1 from "./CustomUIProject.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909a1542",
  null
  
)

export default component.exports